import { Routes } from "@angular/router";
import { DashboardComponent } from "./shared/layouts/dashboard/dashboard.component";
import { AuthGuard } from "./shared/services/guard.service";

export const APP_ROUTES: Routes = [
    {
        path: "authentication",
        loadChildren: () => import("./modules/authentication/auth.routes").then((m) => m.AUTH_ROUTES),
    },
    // {
    //     path: "flash",
    //     canActivate: [AuthGuard],
    //     component: DashboardComponent,
    //     children: [
    //         { path: "", pathMatch: "full", redirectTo: "claims" },
    //         {
    //             path: "policies",
    //             loadChildren: () =>
    //                 import("./modules/flash-policies/flash-policies.routes").then((r) => r.POLICIES_ROUTES),
    //         },
    //         {
    //             path: "claims",
    //             loadChildren: () => import("./modules/flash-claims/flash-claims.routes").then((r) => r.CLAIMS_ROUTES),
    //         },
    //     ],
    // },
    {
        path: "tts",
        canActivate: [AuthGuard],
        component: DashboardComponent,
        children: [
            { path: "", pathMatch: "full", redirectTo: "policies" },
            {
                path: "policies",
                loadChildren: () =>
                    import("./modules/tts-policies/tts-policies.routes").then((r) => r.TTS_POLICIES_ROUTES),
            },
            {
                path: "claims",
                loadChildren: () => import("./modules/tts-claims/tts-claims.routes").then((r) => r.TTS_CLAIMS_ROUTES),
            },
        ],
    },
    {
        path: "shopee-food",
        canActivate: [AuthGuard],
        component: DashboardComponent,
        children: [
            { path: "", pathMatch: "full", redirectTo: "declarations" },
            {
                path: "declarations",
                loadChildren: () =>
                    import("./modules/shopee-food-declarations/shopee-food-declarations.routes").then(
                        (r) => r.SHOPEE_FOOD_DECLARATIONS_ROUTES,
                    ),
            },
            {
                path: "claims",
                loadChildren: () =>
                    import("./modules/shopee-food-claims/shopee-food-claims.routes").then(
                        (r) => r.SHOPEE_FOOD_CLAIMS_ROUTES,
                    ),
            },
        ],
    },
    {
        path: "**",
        redirectTo: "authentication/login",
    },
];
